import { initializeApp } from 'firebase/app';
import {
  getAuth, signInWithEmailAndPassword, signOut,
  onAuthStateChanged, createUserWithEmailAndPassword,
  reauthenticateWithCredential, updatePassword, EmailAuthProvider
} from 'firebase/auth';
import {
  getFirestore, collection, doc, addDoc, setDoc, getDoc,
  getDocs, updateDoc, deleteDoc, onSnapshot, query,
  orderBy, where, serverTimestamp, runTransaction,
  initializeFirestore, persistentLocalCache, persistentMultipleTabManager
} from 'firebase/firestore';

// Exported for secondary app instances in AdminModule/OrdersModule (user creation)
export const firebaseConfig = {
  apiKey: "AIzaSyD2sAXPekfcbS91IfdJlcNw0L-H0eRlvMI",
  authDomain: "tof-orders.firebaseapp.com",
  projectId: "tof-orders",
  storageBucket: "tof-orders.firebasestorage.app",
  messagingSenderId: "63492426636",
  appId: "1:63492426636:web:ca89f3ac0b323f2ef564a9"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = initializeFirestore(app, {
  localCache: persistentLocalCache({ tabManager: persistentMultipleTabManager() })
});

export const toEmail = ph => `${ph.trim().replace(/\s+/g, '')}@tof.app`;

export {
  signInWithEmailAndPassword, signOut, onAuthStateChanged,
  createUserWithEmailAndPassword, getAuth,
  reauthenticateWithCredential, updatePassword, EmailAuthProvider,
  collection, doc, addDoc, setDoc, getDoc, getDocs,
  updateDoc, deleteDoc, onSnapshot, query, where, orderBy, serverTimestamp, runTransaction
};
